import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Icon, IconButton, Stack, Typography } from "@mui/material";
import { Component } from "react";
import BasicDataGrid from "../ui/BasicDataGrid";
import { MdBackHand, MdClose, MdDownload, MdOutlineLink, MdOutlineLinkOff, MdOutlineSettingsSuggest, MdOutlineTroubleshoot, MdPlayArrow, MdStop } from "react-icons/md";
import { IoMdPaper } from "react-icons/io"
import { GoArrowSwitch } from "react-icons/go"
import { HiOutlineDocumentReport } from "react-icons/hi"
import { TbReportAnalytics } from "react-icons/tb"
import { httpGet, httpPost } from "../util/http";
import dayjs from "dayjs";
import { INVENTARIO_ABERTO, INVENTARIO_CONCLUIDO, INVENTARIO_EM_CONTAGEM, INVENTARIO_EXPIRADO } from "../util/contants";
import UsuarioSelect from "../ui/UsuarioSelect";
import { FaCheck } from "react-icons/fa";
import ManualCount from "../ui/ManualCount";
import ProdEdit from "../ui/ProdEdit";
import Cookies from "universal-cookie";
import EstoqueInventarioDialog from "../ui/EstoqueInventarioDialog";

export default class Inventario extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            btnLoading: false,
            maxCnt: 0,
            recrutas: [],
            recrutados: [],
            finalizados: [],
            recrutDialog: false,
            value: null,
            showSuccess: false,
            showExpirado: false,
            showManualCount: false,
            showProdEdit: false,
            showEstoque: false,
        }

        this.columns = [
            { field: 'num', headerName: 'Nº', width: 15, valueGetter: (params) => params.row?.num },
            { field: 'hora_inicio', headerName: 'Hora de início', flex: 1, valueGetter: (params) => dayjs(params.row?.created_at).format('HH:mm') },
            { field: 'hora_fim', headerName: 'Hora de término', flex: 1, valueGetter: (params) => params.row?.encerramento ? dayjs(params.row?.encerramento).format('HH:mm') : '-' },
            {
                field: 'download', headerName: 'Listagem', renderCell: (params) =>
                    <>
                        <IconButton disabled={params.row?.encerramento == null} title="Relatório detalhado da contagem" color="primary" onClick={e => window.open(process.env.REACT_APP_API_URL + '/relatorios/detcont/' + params.row?.uuid, '_blank')}><TbReportAnalytics size={20} /></IconButton>
                        {this.props.inventario?.tipo === 1 ?
                            <IconButton disabled={params.row?.encerramento != null} title="Download listagem" color="primary" onClick={e => window.open(process.env.REACT_APP_API_URL + '/relatorios/produtos2/' + params.row?.uuid, '_blank')}><MdDownload size={18} /></IconButton>
                            :
                            <IconButton title="Download listagem" color="primary" onClick={e => window.open(process.env.REACT_APP_API_URL + '/relatorios/produtos/' + params.row?.uuid, '_blank')}><MdDownload size={18} /></IconButton>
                        }
                    </>
            },

        ];

        this.cookies = new Cookies();
        this.user = this.cookies.get('user');
    }

    addRecruta(colab) {
        this.setState((prevState) => {
            const alreadyExists = prevState.recrutas.some(
                (recruta) => recruta.sapiens_codusu === colab.sapiens_codusu
            );

            if (!alreadyExists) {
                return {
                    recrutas: [...prevState.recrutas, colab],
                };
            } else {
                return null;
            }
        });
    }

    removerRecruta = (codusu) => {
        this.setState((prevState) => ({
            recrutas: prevState.recrutas.filter((recruta) => recruta.sapiens_codusu !== codusu)
        }));
    };

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.setState({ loading: true });
        httpGet('/inventarios/' + this.props.inventario?.id + '/read',
            data => {
                console.log(data)
                this.setState({
                    inventario: data.inventario,
                    maxCnt: data.max_cnt,
                    loading: false,
                    showExpirado: data.inventario.status === INVENTARIO_EXPIRADO,
                    showSuccess: data.inventario.status === INVENTARIO_CONCLUIDO,
                });
            },
            error => {
                console.log(error);
                this.setState({ loading: false });
            },
        );
    }

    recrutas() {
        this.setState({ loadingRecrutados: true });
        console.log(this.state.inventario);
        httpGet('/recrutas/' + this.state.inventario?.deposito?.sapiens_coddep,
            users => {
                let recrutados = [];
                let finalizados = [];
                if (users.ativos.length > 0) {
                    users.ativos.forEach(u => {
                        let attrs = u.split(' ');
                        let isConn = false;
                        if (attrs[1] === '(C)') {
                            isConn = true;
                        }
                        recrutados.push({ nome: attrs[0], isConn });
                    });
                }

                if (users.finalizados.length > 0) {
                    users.finalizados.forEach(u => {
                        finalizados.push({ nome: u.split(' ')[0] });
                    });
                }

                this.setState({
                    recrutados,
                    finalizados,
                    loadingRecrutados: false,
                });
            },
            error => {
                console.log(error);
                this.setState({ loadingRecrutados: false });
            },
        );
    }

    getpostfix() {
        return this.props.semanal ? 'semanal' : '';
    }

    contagemstatus(start) {
        this.setState({ btnLoading: true });
        httpPost('/inventarios/' + this.props.deposito?.id + (start ? '/startcount' + this.getpostfix() : '/stopcount' + this.getpostfix()),
            {},

            resp => {
                /* Esse trecho de código é apenas para
                atualizar antecipadamente os status e evitar
                ação precoce do usuário que pode levar à quebra do fluxo. */
                if (start) {
                    this.props.deposito.status = INVENTARIO_EM_CONTAGEM;
                } else {
                    this.props.deposito.status = INVENTARIO_ABERTO;
                }

                this.refresh();
                if (this.props.onRefresh) {
                    this.props.onRefresh();
                }
                this.setState({ btnLoading: false });
            },

            error => {
                this.setState({
                    btnLoading: false,
                });
                console.error(error);
            },

            false
        );
    }

    recrutamento() {
        this.setState({ btnLoading: true });
        httpPost('/inventarios/' + this.props.deposito?.id + '/recrutamento',
            { recrutas: this.state.recrutas },

            resp => {
                this.setState({ btnLoading: false, recrutDialog: false, recrutas: [] });
            },

            error => {
                this.setState({
                    btnLoading: false,
                });
                console.error(error);
            },

            false
        );
    }

    manualCountClose(refresh) {
        this.setState({ showManualCount: false });
        if (refresh) {
            this.refresh();
            if (this.props.onRefresh) {
                this.props.onRefresh();
            }
        }
    }

    showRecrutamento() {
        this.recrutas();
        this.setState({ recrutDialog: true });
    }

    render() {
        return (
            <Dialog open={true}>
                <DialogTitle color="primary" fontSize={12}>INVENTÁRIO</DialogTitle>
                <IconButton onClick={e => this.props.onClose(e)} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <MdClose size={18} />
                </IconButton>
                <DialogContent>
                    {this.state.showEstoque && <EstoqueInventarioDialog inventarioId={this.props.inventario?.id} onClose={() => this.setState({ showEstoque: false })} />}
                    {this.state.showManualCount && <ManualCount inventario={this.props.inventario} onClose={refresh => this.manualCountClose(refresh)} />}
                    {this.state.showProdEdit && <ProdEdit inventario={this.state.inventario} onClose={() => this.setState({ showProdEdit: false })} />}
                    <Dialog open={this.state.recrutDialog}>
                        <DialogTitle color="primary" fontSize={12}>RECRUTAMENTO DE PESSOAL</DialogTitle>
                        <IconButton onClick={e => this.setState({ recrutDialog: false, recrutas: [] })} sx={{ position: 'absolute', right: 8, top: 8 }}>
                            <MdClose size={18} />
                        </IconButton>
                        <DialogContent>
                            <Stack width={400} mt={-2}>
                                <Typography variant="caption" mb={2}>Selecione os colaboradores que participarão da contagem.</Typography>
                                <UsuarioSelect unidadeId={this.props.deposito?.unidade_id} value={this.state.value} onChange={colab => this.addRecruta(colab)} />
                                <Stack mt={1}>
                                    {this.state.recrutas.map((colab, i) =>
                                        <Stack direction="horizontal" alignItems={"center"}>
                                            <Typography variant="caption">{colab.nome}</Typography>
                                            <IconButton onClick={() => this.removerRecruta(colab.sapiens_codusu)}>
                                                <MdClose color="red" size={15} />
                                            </IconButton>
                                        </Stack>
                                    )}
                                </Stack>
                                <Typography variant="caption" fontWeight={500} mt={2}><b>Colaboradores recrutados</b></Typography>
                                <Stack>
                                    {this.state.recrutados.length == 0 && <Typography variant="caption">Ninguém recrutado ainda.</Typography>}
                                    {this.state.recrutados.map((colab, i) =>
                                        <Stack direction="horizontal" alignItems={"center"}>
                                            <Typography variant="caption">{colab.nome}</Typography>
                                            {colab.isConn ?
                                                <Box color="green" mt={0.5} ml={0.5}><MdOutlineLink /></Box> :
                                                <Box color="red" mt={0.5} ml={0.5}><MdOutlineLinkOff /></Box>
                                            }

                                        </Stack>
                                    )}
                                </Stack>

                                <Typography variant="caption" fontWeight={500} mt={2}><b>Colaboradores que finalizaram</b></Typography>
                                <Stack>
                                    {this.state.finalizados.length == 0 && <Typography variant="caption">Ninguém finalizou ainda.</Typography>}
                                    {this.state.finalizados.map((colab, i) =>
                                        <Stack direction="horizontal" alignItems={"center"}>
                                            <Typography variant="caption">{colab.nome}</Typography>
                                        </Stack>
                                    )}
                                </Stack>
                            </Stack>
                        </DialogContent>
                        <DialogActions>
                            {this.state.btnLoading ? <CircularProgress size={20} sx={{ mr: 8 }} /> : (this.state.recrutas.length > 0 && <Button size="small" color="success" onClick={e => this.recrutamento()}>Adicionar</Button>)}
                        </DialogActions>
                    </Dialog>


                    <Stack width={550} mt={-2}>
                        <Stack direction="row" gap={1} mb={1}>
                            {this.state.loading ?
                                <></>
                                :
                                ((this.state.showSuccess) || (this.state.showExpirado)) ?
                                    <Stack flex={1} direction={"row"}>
                                        <Stack height={30} justifyContent={"center"} borderRadius={1} width={200} bgcolor={this.state.showExpirado ? '#fff0f1' : '#f2fff0'}>
                                            <Typography color={this.state.showExpirado ? '#7d2e2e' : '#2e7d32'} variant="caption" width="100%" textAlign="center"><b>{this.state.showExpirado ? 'CONTAGEM EXPIRADA' : 'CONTAGEM CONCLUÍDA'}</b><Box component="span" ml={1} /><FaCheck /></Typography>
                                        </Stack>
                                        {this.user?.isAdmin &&
                                            <>

                                                {/* <IconButton title="Relatório final" sx={{ width: 40 }} color="primary" onClick={e => window.open(process.env.REACT_APP_API_URL + '/relatorios/final/' + this.props.inventario?.uuid, '_blank')}>
                                                    <TbReportAnalytics size={20} />
                                                </IconButton> */}
                                            </>
                                        }
                                        {(this.props.deposito?.status == INVENTARIO_ABERTO) &&
                                            <Button onClick={e => this.setState({ showManualCount: true })} size="small" startIcon={<MdBackHand />} color="success" variant="contained" disableElevation>Contagem manual</Button>
                                        }
                                    </Stack>
                                    :
                                    this.props.deposito?.status == INVENTARIO_EM_CONTAGEM ?
                                        <>
                                            <Button onClick={e => this.contagemstatus(false)} size="small" startIcon={this.state.btnLoading ? <CircularProgress sx={{ color: 'rgba(0, 0, 0, 0.26)' }} size={20} /> : <MdStop />} color="error" variant="contained" disableElevation disabled={this.state.btnLoading}>Encerrar contagem</Button>
                                            <Button onClick={e => this.showRecrutamento()} size="small" color="success" variant="contained" disableElevation disabled={this.state.btnLoading}>Fazer recrutamento</Button>
                                        </>
                                        :
                                        <>
                                            {(this.state.inventario?.contagens?.length < this.state.maxCnt) &&
                                                <Button onClick={e => this.contagemstatus(true)} size="small" startIcon={this.state.btnLoading ? <CircularProgress sx={{ color: 'rgba(0, 0, 0, 0.26)' }} size={20} /> : <MdPlayArrow />} color="success" variant="contained" disableElevation disabled={this.state.btnLoading}>Iniciar contagem</Button>
                                            }
                                            {(this.state.inventario?.contagens?.length > 0) &&
                                                <Button onClick={e => this.setState({ showManualCount: true })} size="small" startIcon={<MdBackHand />} color="success" variant="contained" disableElevation>Contagem manual</Button>
                                            }
                                        </>
                            }
                            {(this.state.inventario?.contagens?.length > 0) &&
                                <IconButton title="Relatório de contagem" sx={{ width: 40 }} color="primary" onClick={e => window.open(process.env.REACT_APP_API_URL + '/relatorios/contagens/' + this.props.inventario?.uuid, '_blank')}>
                                    <HiOutlineDocumentReport size={20} />
                                </IconButton>
                            }
                            {this.user?.isAdmin && (this.props.deposito?.status != INVENTARIO_CONCLUIDO) &&
                                <>
                                    <IconButton title="Ajustar produto" sx={{ width: 40 }} color="primary" onClick={() => this.setState({ showProdEdit: true })}><MdOutlineSettingsSuggest size={20} /></IconButton>
                                </>
                            }
                            {this.props.semanal && <IconButton title="Movimento dos produtos" sx={{ width: 40 }} color="primary" onClick={e => this.setState({ showEstoque: true })}>
                                <GoArrowSwitch size={18} />
                            </IconButton>}
                            <IconButton title="Relatório de apuração" sx={{ width: 40 }} color="primary" onClick={() => window.open(process.env.REACT_APP_API_URL + '/apuracao/relatorio/' + this.props.inventario?.uuid, '_blank')}>
                                <MdOutlineTroubleshoot size={20} />
                            </IconButton>
                        </Stack>
                        <BasicDataGrid
                            props={{
                                //onRowClick: e => this.onUnidFichaClick(),
                                loading: this.state.loading
                            }} rows={this.state.inventario?.contagens ? this.state.inventario?.contagens : []} columns={this.columns} />
                    </Stack>
                </DialogContent>
            </Dialog>
        );
    }
}
